import { TextArea } from '@navi/web-ui/lib/primitives';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { COMMENT_VALIDATIONS } from '../../constants';
import { useDispatch } from 'react-redux';
import { AnomalyStatus, AnomalyTableKeys, IResolveAnomalyDefaultValues } from '../../types';
import { createQueryParams, readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { getAnomalyTickets, resolveAnomaly } from '../../actions/AnomalyTrackerAction';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_ROUTES_PATHS_WITH_PATH_PARAM } from '@cp/src/layout/Routes';
import { LocalStorage } from '@cp/src/utils/StorageUtils';
import AnomalySubmitCta from '../ETA/AnomalySubmitCta';
import ResolveAnomalyPopup from './ResolveAnomalyPopup';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';

const PARAMS_MAP_KEY = 'paramsMap';

const ResolveAnomaly = () => {
  const dispatch = useDispatch();
  const params = readQueryParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const selectedAnomalyId = params?.[AnomalyTableKeys.ANOMALY_TABLE_ACTION]?.selectedId;
  const {
    watch,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm<IResolveAnomalyDefaultValues>({
    defaultValues: {
      comment: ''
    }
  });

  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);

  const comment = watch('comment');

  const successCallback = () => {
    const paramsMap: Record<string, string> = LocalStorage.getItem(PARAMS_MAP_KEY) || {};
    const params = readQueryParams();
    delete params?.[AnomalyTableKeys.ANOMALY_TABLE_ACTION];
    const url = createQueryParams(params);
    paramsMap[pathname] = url;
    LocalStorage.setItem(PARAMS_MAP_KEY, JSON.stringify(paramsMap));
    dispatch(getAnomalyTickets(AnomalyStatus.OPEN, params?.openAnomalyTable, false));
    navigate(APP_ROUTES_PATHS_WITH_PATH_PARAM.ANOMALY_TRACKER.closed);
  };

  const resolveAnomalyHandler = (data: IResolveAnomalyDefaultValues) => {
    addClickstreamEvent(
      CLICKSTREAM_EVENT_NAMES.LH_ANOMALY_TRACKER_ANOMALY_RESOLVED_SUBMIT_BUTTON_CLICKED,
      {
        anomalyId: selectedAnomalyId
      }
    );
    setShowConfirmationPopup(false);
    dispatch(resolveAnomaly(selectedAnomalyId, { resolution: data }, successCallback));
  };

  const toggleConfirmationPopup = () => {
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  return (
    <>
      <form className="p-6 overflow-scroll m-0">
        <Controller
          control={control}
          name="comment"
          rules={COMMENT_VALIDATIONS}
          render={({ field: { onChange, value } }) => (
            <TextArea
              label="Enter Reason to resolve anomaly"
              rows={5}
              containerClassName="w-full"
              required
              placeholder="Type here..."
              onChange={onChange}
              value={value}
              error={errors?.comment?.message}
            />
          )}
        />
      </form>
      <div className="p-4 border-0 border-t border-solid border-[var(--navi-color-gray-border)]">
        {!showConfirmationPopup ? (
          <AnomalySubmitCta disabled={!comment} onSubmit={handleSubmit(toggleConfirmationPopup)} />
        ) : (
          <ResolveAnomalyPopup
            toggleConfirmationPopup={toggleConfirmationPopup}
            onSubmit={handleSubmit(resolveAnomalyHandler)}
          />
        )}
      </div>
    </>
  );
};

export default ResolveAnomaly;
